/* תשלומים עתידיים ידועים: יתרת תשלומים של עסקה, וחיובי חו"ל נדחים */
import { S } from './state.js';
import { mNorm } from '../lib/text.js';
import { fISO, todayISO, iso10, cents, absAmt } from '../lib/format.js';
import { getTxSrc } from './tx.js';
import { keyOfISO } from './periods.js';
import { cardChargeDay } from './card.js';

/** התשלום של החודש הזה כבר נסרק מדוח (אותו שם, אותו סכום, אותה תקופת חיוב)? */
export function commitAlreadyScanned(desc, amount, due) {
  const name = mNorm(String(desc || '').replace(/\(תשלום[^)]*\)/, '')).slice(0, 10);
  if (!name || !due) return false;
  const k = keyOfISO(due);
  return S.tx.some((t) => getTxSrc(t) === 'credit' && t.month === k && cents(t.amount) === cents(amount) &&
    mNorm(t.raw_name || t.description).indexOf(name) === 0);
}

/** התחייבויות שכבר לא עתידיות: עבר המועד (עם מרווח עד שהעו"ש של אותו חיוב נסרק), או כבר בדוח */
export function staleCommits() {
  const keep = fISO(new Date(Date.now() - 40 * 864e5));
  return S.commits.filter((c) => c.due_date < keep || (c.kind === 'installment' && commitAlreadyScanned(c.description, c.amount, c.due_date)));
}

/** התחייבויות שהתממשו בסריקה: תשלום שהגיע, או חיובי חו"ל שהדוח שלהם נסרק */
export function realizedCommits(items, chargeDate) {
  const kill = new Set();
  (items || []).forEach((it) => {
    if (!it.instNum || !it.instTotal) return;
    const tag = '(תשלום ' + it.instNum + '/' + it.instTotal + ')';
    S.commits.forEach((c) => {
      if (c.kind !== 'installment' || c.description.indexOf(tag) < 0) return;
      const da = Math.abs(Number(c.amount) - Math.abs(Number(it.amount)));
      if (da <= Math.abs(Number(it.amount)) * 0.02 + 0.5) kill.add(c);
    });
  });
  if (chargeDate) S.commits.forEach((c) => { if (c.kind === 'deferred' && String(c.due_date) <= chargeDate) kill.add(c); });
  return [...kill];
}

/** התחייבויות חדשות מסריקה: יתרת תשלומים ("תשלום 3 מתוך 6") וחיובי חו"ל נדחים */
export function commitsFromScan(installments, deferred) {
  const out = [], today = todayISO(), chargeDay = cardChargeDay();
  (installments || []).forEach((r) => {
    const left = r.instTotal - r.instNum;
    if (left < 1) return;
    let base = r.date ? new Date(iso10(r.date) + 'T12:00:00') : new Date();
    if (isNaN(base.getTime())) base = new Date();
    for (let i = 1; i <= left; i++) {
      // ביום החיוב של הכרטיס, כדי שהתשלום יישב במחזור הנכון. בחודש קצר: היום האחרון שלו
      const d = new Date(base.getFullYear(), base.getMonth() + i, Math.min(chargeDay, new Date(base.getFullYear(), base.getMonth() + i + 1, 0).getDate()));
      // דוח ישן: תשלום שכבר ירד, או שכבר מופיע בדוח מאוחר יותר, לא נרשם כעתידי
      if (fISO(d) < today || commitAlreadyScanned(r.name, r.amount, fISO(d))) continue;
      out.push({ description: r.name + ' (תשלום ' + (r.instNum + i) + '/' + r.instTotal + ')', amount: Math.abs(r.amount), due_date: fISO(d), kind: 'installment' });
    }
  });
  if (deferred && deferred.amount > 0 && deferred.date >= today) {
    out.push({
      description: 'חיובי חו"ל נדחים' + (deferred.count ? ' (' + deferred.count + ' עסקאות)' : ''),
      amount: deferred.amount, due_date: deferred.date, kind: 'deferred',
    });
  }
  // סריקה חוזרת של אותו דוח לא תיצור כפילות
  return out.filter((rec) => !S.commits.some((c) => c.description === rec.description && String(c.due_date) === String(rec.due_date)));
}

export function commitAmount(c) {
  return absAmt(c);
}
